module.exports = __webpack_public_path__ + "static/media/whatsapp-logo1 (1).60ab48ec.webp";